import type { Pinia } from 'pinia'
import { cartPiniaPlugin } from '@/store-plugins/cart.ts'
import { deliveryPiniaPlugin } from '~/store-plugins/delivery.ts'
import { paymentPiniaPlugin } from '~/store-plugins/payment.ts'
import { orderPiniaPlugin } from '~/store-plugins/order.ts'

export default defineNuxtPlugin(async (nuxtApp) => {
  onShowLogs(() => {
    const route = useRoute()
    console.log(`\x1B[33m________ req on ${process.client ? 'client' : 'server'} ________ \x1B[0m`)
    console.log(`Time: ${new Date().toLocaleString()}`)
    console.log(`Path: ${route.fullPath}\n`)
    if (process.server)
      console.log('💽 hello from server')
  })

  const { $pinia } = nuxtApp;
  ($pinia as Pinia).use(cartPiniaPlugin)
    .use(deliveryPiniaPlugin)
    .use(paymentPiniaPlugin)
    .use(orderPiniaPlugin)

  // log any errors to the console
  nuxtApp.hook('vue:error', (error, instance, info) => {
    onShowLogs(() => console.log('vue:error', error, instance, info))
  })
})
